
import React from 'react';
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Trip } from "@/types/itinerary";
import { InviteLinkShare } from '@/components/travel/InviteLinkShare';

interface ItineraryHeaderProps {
  trip: Trip | null;
  canEdit: boolean;
  onAddEvent: () => void;
}

const ItineraryHeader: React.FC<ItineraryHeaderProps> = ({ 
  trip, 
  canEdit, 
  onAddEvent 
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-[#0A3D62]">Itinerary</h1>
        <p className="text-muted-foreground">{trip?.description}</p>
      </div>
      
      <div className="flex gap-2">
        {trip && (
          <InviteLinkShare 
            tripId={trip.id} 
            tripName={trip.name}
          />
        )}
        
        {canEdit && (
          <Button 
            onClick={onAddEvent} 
            className="bg-glowingTeal hover:bg-navteal btn-glow"
          >
            <Plus size={18} className="mr-1" /> Add Event
          </Button>
        )}
      </div>
    </div>
  );
};

export default ItineraryHeader;
